import { render, staticRenderFns } from "./TrModal.vue?vue&type=template&id=682dae6a&scoped=true&"
import script from "./TrModal.vue?vue&type=script&lang=ts&"
export * from "./TrModal.vue?vue&type=script&lang=ts&"
import style0 from "./TrModal.vue?vue&type=style&index=0&id=682dae6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682dae6a",
  null
  
)

export default component.exports